import { ConstantsService } from 'src/app/services/constants.service';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UmbralesService {
  private url = ConstantsService.UMBRALES_URL;
  constructor(private http:HttpClient) { }

  list(query: string = ''): Observable<any>{
    return this.http.get<{}>(`${this.url}${query}`).pipe(map(data => {
     return data;
    }));
 }
 create(formData:any): Observable<any>{
  return this.http.post(`${this.url}`, formData).pipe(map(data => {
    return data;
  }));
}

update(formData:any): Observable<any>{
  let {idSprUmbral} = formData;
  return this.http.patch(`${this.url}${idSprUmbral}`,formData).pipe(map(
    data => {
      return data;
    }
  ));
}
delete(dataDelete:any): Observable<any>{
  return this.http.patch(`${this.url}${dataDelete.idSprUmbral}`,dataDelete).pipe(map(data => {
    return data;
  }));
}

}
